import React from "react";
import { Row, Col, Input, InputNumber, Button } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

// A blank variant row. `id` is only present for variants that already exist in the DB.
const blankVariant = () => ({
  name: "",
  weight: "",
  sku: "",
  price: 0,
  stock_qty: 0,
  status: "1",
});

function VariantsEditor(props) {
  const { variants, setVariants, errorField, setErrorField } = props;
  const list = Array.isArray(variants) ? variants : [];

  const updateRow = (index, field, value) => {
    const next = list.map((v, i) => (i === index ? { ...v, [field]: value } : v));
    setVariants(next);
    if (setErrorField) setErrorField(errorField.filter((x) => x !== "variants"));
  };

  const addRow = () => {
    setVariants([...list, blankVariant()]);
  };

  const removeRow = (index) => {
    setVariants(list.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginTop: 6 }}>
      <div className="shop-section-head">
        <h4 className="shop-section-title">
          Variants&nbsp;<span style={{ color: "var(--greyColor)", fontWeight: 400 }}>(weights / sizes)</span>
          <span className="req">*</span>
        </h4>
        <Button className="shop-add-btn" icon={<PlusOutlined />} onClick={addRow}>
          Add variant
        </Button>
      </div>

      {errorField && errorField.includes("variants") && (
        <div className="shop-variant-error">
          Add at least one variant with a weight/size.
        </div>
      )}

      {list.length === 0 && (
        <div className="shop-variant-empty">
          No variants yet. Click <b>Add variant</b> to add a weight/size (e.g. 250g) with its price and stock.
        </div>
      )}

      {list.length > 0 && (
        <Row gutter={10} className="shop-variant-colhead">
          <Col span={6}>Weight / Size</Col>
          <Col span={6}>SKU / Code</Col>
          <Col span={6}>Price</Col>
          <Col span={6}>Stock</Col>
        </Row>
      )}

      {list.map((v, index) => (
        <div className="shop-variant-row" key={index}>
          <Row gutter={10} align="middle">
            <Col span={6}>
              <Input
                placeholder="e.g. 250g"
                value={v.weight || ""}
                onChange={(e) => updateRow(index, "weight", e.target.value)}
              />
            </Col>
            <Col span={6}>
              <Input
                placeholder="SKU"
                value={v.sku || ""}
                onChange={(e) => updateRow(index, "sku", e.target.value)}
              />
            </Col>
            <Col span={6}>
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                step={0.01}
                placeholder="0.00"
                value={v.price}
                onChange={(value) => updateRow(index, "price", value === null ? 0 : value)}
              />
            </Col>
            <Col span={6}>
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                step={1}
                placeholder="0"
                value={v.stock_qty}
                onChange={(value) => updateRow(index, "stock_qty", value === null ? 0 : value)}
              />
            </Col>
          </Row>
          <Button
            type="text"
            className="shop-variant-del"
            icon={<DeleteOutlined />}
            onClick={() => removeRow(index)}
          />
        </div>
      ))}
    </div>
  );
}

export default VariantsEditor;
